import * as React from 'react';
import { useInputController } from '../hooks/useInputController.ts';

export interface IAsyncSelectInputObjectProps {
  name: string;
}

export interface IAsyncSelectInputObjectRef {
  onChange: (value: any) => void;
  ref: React.RefCallback<any>;
}

export const AsyncSelectInputObject = React.forwardRef(
  (
    props: IAsyncSelectInputObjectProps,
    ref: React.Ref<IAsyncSelectInputObjectRef>,
  ) => {
    const { name } = props;
    const {
      field: { value, onChange, onBlur, ref: objectRef },
    } = useInputController(name, { enabled: true });

    React.useImperativeHandle(ref, () => ({
      onChange: (value: any) => {
        console.log('object.onChange', value);
        onChange(value);
      },
      ref: objectRef,
    }));

    return null;
  },
);
